import { AttributeReferenceInfo } from './attributeReferenceInfo';

export class DocumentTypeAttribute {
    id: string;
    typeId: string;
    code: string;
    name: string;
    systemCode: string;
    isMandatory?: boolean;
    isReadOnly?: boolean;
    defaultFilter?: string;
    referenceInfo?: AttributeReferenceInfo;

    /**
     *
     */
    constructor() {
      this.id = null;
      this.typeId = '';
      this.name = '';
      this.code = '';
      this.systemCode = '';
    }
  }
